import {
    DEFAULT_TEXT_SCALE,
    TEXT_SCALE_STEPS,
    clampTextScale,
    nextTextScale,
} from '../../helpers/questionnaire/textScale';

/**
 * Tekstgrootte-knoppen rechtsboven op de open vragenlijst.
 *
 * Waarom knoppen en geen keuzelijst: de respondent moet het verschil kúnnen
 * zien terwijl hij kiest. Een klik, meteen resultaat, en de middelste knop
 * brengt hem in één keer terug — anders moet iemand die te ver is doorgeklikt
 * gaan tellen.
 *
 * Alle drie zijn echte `<button>`-elementen met een uitgeschreven naam, want
 * deze pagina kent geen inlog en wordt met van alles bezocht: toetsenbord,
 * schermlezer, telefoon. Een `<div>` met een klikhandler is voor geen van die
 * drie een knop.
 *
 * @param {object} props
 * @param {number} props.scale - Huidige vermenigvuldiger (een van TEXT_SCALE_STEPS)
 * @param {(next: number) => void} props.onChange - Krijgt de nieuwe stand
 */
const TextSizeSwitcher = ({ scale, onChange }) => {
    const current = clampTextScale(scale);
    const smallest = TEXT_SCALE_STEPS[0];
    const largest = TEXT_SCALE_STEPS[TEXT_SCALE_STEPS.length - 1];

    return (
        <div className='qo-text-size' role='group' aria-label='Tekstgrootte'>
            <button
                type='button'
                className='qo-text-size-button'
                aria-label='Tekst kleiner'
                disabled={current === smallest}
                onClick={() => onChange(nextTextScale(current, -1))}
            >
                A<span className='qo-text-size-sign' aria-hidden='true'>−</span>
            </button>
            <button
                type='button'
                className='qo-text-size-button qo-text-size-reset'
                aria-label='Tekst normaal'
                aria-pressed={current === DEFAULT_TEXT_SCALE}
                disabled={current === DEFAULT_TEXT_SCALE}
                onClick={() => onChange(DEFAULT_TEXT_SCALE)}
            >
                A
            </button>
            <button
                type='button'
                className='qo-text-size-button'
                aria-label='Tekst groter'
                disabled={current === largest}
                onClick={() => onChange(nextTextScale(current, 1))}
            >
                A<span className='qo-text-size-sign' aria-hidden='true'>+</span>
            </button>
        </div>
    );
};

export default TextSizeSwitcher;
